var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerpPerpIcon = function SvgPerpPerpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#PerpPerpIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.778 6.133H6.222c-.533 0-.889-.355-.889-.889 0-.533.356-.888.89-.888h3.555c.533 0 .889.355.889.888 0 .534-.356.89-.89.89Zm0 3.467H6.222c-.533 0-.889-.356-.889-.889s.356-.889.89-.889h3.555c.533 0 .889.356.889.89 0 .532-.356.888-.89.888Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.333 1.778v11.91l-4.178-2.044A2.738 2.738 0 0 0 8 11.378c-.356 0-.8.089-1.156.266L2.666 13.69V1.778h10.667Zm0-1.778H2.666C1.69 0 .89.8.89 1.778V15.11a.89.89 0 0 0 .889.889c.088 0 .266 0 .355-.089l5.422-2.667c.09-.088.267-.088.356-.088.089 0 .267 0 .355.088l5.423 2.667c.266.089.444.089.533.089a.89.89 0 0 0 .889-.889V1.778C15.11.8 14.31 0 13.333 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PerpPerpIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgPerpPerpIcon;